
document.addEventListener('DOMContentLoaded', function() {

setTimeout(() => {
    // Función para cambiar la cantidad de productos, específica a cada tarjeta
    document.querySelectorAll('.mox-subs-container').forEach(container => {
        const quantityDisplay = container.querySelector('.mox-subs-quantity-display');
        let quantity = parseInt(quantityDisplay.textContent);
        container.querySelector('.mox-subs-increase').addEventListener('click', () => {
            quantity++;
            quantityDisplay.textContent = quantity;
        });

        container.querySelector('.mox-subs-decrease').addEventListener('click', () => {
            if (quantity > 1) {
                quantity--;
                quantityDisplay.textContent = quantity;
            }
        });
    });

//  Selecciona todos los elementos con la clase 'mox-subscription-button'
const subscriptionButtons = document.querySelectorAll('.mox-subscription-button');

//  Iterar sobre cada 'mox-subscription-button'
subscriptionButtons.forEach((subscriptionButton) => {
  //  Encuentra el div hermano con clase 'mox-subs-container' y extrae la cantidad
  const subsContainer = subscriptionButton.closest('.t4s-product-btns').previousElementSibling;

  const quantityDisplay = subsContainer.querySelector('.mox-subs-quantity-display').textContent.trim();

  //  Extrae el valor del select con id 'delivery-options'
  const deliveryOption = subsContainer.querySelector('.delivery-options');
  //  Encuentra el primer elemento padre con las clases 't4s-product t4s-pr-grid t4s-pr-style6'
  const productElement = subscriptionButton.closest('.t4s-product.t4s-pr-grid.t4s-pr-style6');

  //  Extrae la propiedad 'data-product-options' y convierte el valor de JSON a un objeto
  const productOptions = JSON.parse(productElement.getAttribute('data-product-options'));
  const variantFirstID = productOptions.VariantFirstID;


  subscriptionButton.setAttribute('onClick', `addItemToCart(${variantFirstID}, ${quantityDisplay}, ${deliveryOption.value})`);
});

// Observador de cambios en el texto del elemento con clase 'mox-subs-quantity-display'
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
            reloadBtns();
        }
    });
});

const quantityElement = document.querySelector('.mox-subs-quantity-display');
if (quantityElement) {
    observer.observe(quantityElement, { childList: true, characterData: true, subtree: true });
}

// Detectar cambio en el valor seleccionado del select con id 'delivery-options'
const deliverySelect = document.querySelector('.delivery-options');
if (deliverySelect) {
    deliverySelect.addEventListener('change', function() {
        reloadBtns();
    });
}


  
  
}, "1000");

    const checkboxes = document.querySelectorAll('.pdp-selector-checkbox');

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', function() {
            if (this.checked) {
                checkboxes.forEach(cb => {
                    if (cb.checked == true) {
                        cb.checked = false;
                        cb.setAttribute('checked', ''); 
                    }
                });
              this.checked = true;
              this.checked.setAttribute('checked', '');
            }
        });
    });


/*  Subs component  */


setTimeout(() => {
document.getElementById('compraSubs') && document.getElementById('compraSubs').addEventListener('click', function() {

    // Ocultar el botón con la clase "t4s-product-form__submit"
    let submitButton = document.querySelector('.t4s-product-form__submit');
    if (submitButton) {
        submitButton.style.display = 'none';
    }

    // Mostrar el botón con id "add_subscription_button"
    let subscriptionButton = document.getElementById('add_subscription_button');
    if (subscriptionButton) {
        subscriptionButton.style.display = 'inline-flex';
    }
});


// Función para manejar la compra única y por subs
document.getElementById('compraUnica') && document.getElementById('compraUnica').addEventListener('click', function() {

    // Mostrar el botón con la clase "t4s-product-form__submit"
    let submitButton = document.querySelector('.t4s-product-form__submit');
    if (submitButton) {
        submitButton.style.display = 'inline-flex';
    }

    // Ocultar el botón con id "add_subscription_button"
    let subscriptionButton = document.getElementById('add_subscription_button');
    if (subscriptionButton) {
        subscriptionButton.style.display = 'none';
    }
});

}, "300");
  
});

     

function addItemToCart(variant_id, qty, selling_plan) {
  
    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": selling_plan
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }
    });
  }

function subscriptionPdp(variantFirstID) {
    const checkedCheckbox = document.querySelector('.t4s-product__info-wrapper input[type="checkbox"].pdp-selector-checkbox:checked');
    let quantity = 1; // Valor por defecto
    if (checkedCheckbox) {
        quantity = checkedCheckbox.value; // Asigna el valor del checkbox como quantity
    }


    // Buscar el valor del selector con id 'delivery-options'
    const deliveryOption = document.getElementById('delivery-options');
    let deliveryOptionValue = null;
    if (deliveryOption) {
        deliveryOptionValue = deliveryOption.value; // Obtener el valor del selector
    }

    // Llamar a la función addItemToCart con los valores obtenidos
    if (variantFirstID && deliveryOptionValue) {

        addItemToCart(variantFirstID, quantity, deliveryOptionValue);
    }
}

    function showTabContent(event, tabId) {
      // Ocultar todo el contenido de las pestañas
      var contents = document.querySelectorAll('.tab-content');
      contents.forEach(function(content) {
        content.classList.remove('active');
      });

      // Quitar la clase 'active' de todas las pestañas
      var tabs = document.querySelectorAll('.tab');
      tabs.forEach(function(tab) {
        tab.classList.remove('active');
        tab.classList.add('inactive');
      });

      // Mostrar el contenido seleccionado y marcar la pestaña activa
      document.getElementById(tabId).classList.add('active');
      event.currentTarget.classList.add('active');
      event.currentTarget.classList.remove('inactive');
    }


function reloadBtns() {

const subscriptionButtons = document.querySelectorAll('.mox-subscription-button');

//  Iterar sobre cada mox-subscription-button
subscriptionButtons.forEach((subscriptionButton) => {
  //  Encuentra el div hermano con clase 'mox-subs-container' y extrae la cantidad
  const subsContainer = subscriptionButton.closest('.t4s-product-btns').previousElementSibling;

  const quantityDisplay = subsContainer.querySelector('.mox-subs-quantity-display').textContent.trim();

  //  Extrae el valor del select con id 'delivery-options'
  const deliveryOption = subsContainer.querySelector('.delivery-options');
  //  Encuentra el primer elemento padre con las clases 't4s-product t4s-pr-grid t4s-pr-style6'
  const productElement = subscriptionButton.closest('.t4s-product.t4s-pr-grid.t4s-pr-style6');

  //Extrae la propiedad 'data-product-options' y convierte el valor de JSON a un objeto
  const productOptions = JSON.parse(productElement.getAttribute('data-product-options'));
  const variantFirstID = productOptions.VariantFirstID;


  subscriptionButton.setAttribute('onClick', `addItemToCart(${variantFirstID}, ${quantityDisplay}, ${deliveryOption.value})`);
});
}


/* CALCULAR PRECIO AL CAMBIAR DE PLAN */

$(function () {

  $('[name="purchaseTypeToggle"]').click(function () {
    calculatePrice();
  });

})

function calculatePrice() {
    var value = $('.tab.active').attr('value');

   var subscription_discount = $("#subscription_discount").val();

    original_price = $("#current_variant_price").val();
    compare_price = $("#compare_price_subs").val();

      if (compare_price && compare_price != "") {

        suscription_price= original_price - (original_price * subscription_discount / 100);
      } else {
         suscription_price= original_price - (original_price * subscription_discount / 100);
      }
  
    var selected_value =value;
    var price_ppr ="";

    if (selected_value == "one-time") {


      
      if(document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product__price-review .t4s-product-price ins')){
        price_ppr += formatMoney(original_price);
        $(".t4s-product__info-container.t4s-product__info-container--sticky .t4s-product__price-review .t4s-product-price ins").html(`$${price_ppr}`)
        
      } else {
              
        price_ppr+= formatMoney(original_price);
        $(".t4s-product__info-container.t4s-product__info-container--sticky .t4s-product__price-review .t4s-product-price").html(`$${price_ppr}`)
      }
      




    } else {


      
      if(document.querySelector('.t4s-product__info-container.t4s-product__info-container--sticky .t4s-product__price-review .t4s-product-price ins')){
        price_ppr += formatMoney(suscription_price);
        $(".t4s-product__info-container.t4s-product__info-container--sticky .t4s-product__price-review .t4s-product-price ins").html(`$${price_ppr}`)
        
      } else {
              
        price_ppr += formatMoney(suscription_price);
        $(".t4s-product__info-container.t4s-product__info-container--sticky .t4s-product__price-review .t4s-product-price").html(`$${price_ppr}`)
      }
      



      $("#subscription-price").val(suscription_price);
      $("#subscription-discount").val(subscription_discount);
      
    }

    $("#purchaseTypeToggle_Value").val(selected_value);
  }


function formatMoney(cents) {
    let amount = (cents / 100).toFixed(2); 
    return amount;
}



